import {BasePqForm} from "biz-ts/src/api/Paging";

export class CpqForm extends BasePqForm {
    id?: number

    constructor(id?: number) {
        super();
        this.id = id;
    }
}

export class CcreateForm {
    name = ""
    fullname = ""
    natureKey = ""
}

export class CeditForm {
    id = -1
    name = ""
    fullname = ""
    natureKey = ""
}
